import {Form, Formik} from "formik";
import React from "react";
import NsField from "../../components/fields/NsField";
import {Button, Modal} from "react-bootstrap";
import Translate from "../../components/Translate";

export default function ModalCommentoKpiView({
                                                 commento,
                                                 show,
                                                 handleClose,
                                                 idKpi,
                                                 initialFormValue,
                                                 formikRef,
                                                 signupSchema,
                                                 idCommento,
                                                 onSubmitForm,
                                                 onClickSalva,
                                             }) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            size={"lg"}
            keyboard={false}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{!commento ? 'Inserisci Commento' : commento.modificabile ? 'Modifica Commento' : 'Visualizza Commento'}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Formik
                    initialValues={initialFormValue}
                    innerRef={formikRef}
                    validationSchema={signupSchema}
                    onSubmit={onSubmitForm}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-12">
                                <NsField
                                    name={"testo"}
                                    label={"Testo*:"}
                                    as={'textarea'}
                                    isDisabled={idCommento && (!commento || !commento.modificabile)}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                                <input type="hidden" name="id_kpi" id="id_kpi" value={idKpi}/>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Annulla</Translate>
                </Button>
                <Button variant="primary" onClick={onClickSalva}>
                    <Translate>Salva</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    );
}